import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'loop-dashboard:selectedStoreId';

const readStored = (): string => {
  if (typeof window === 'undefined') return '';
  try {
    return window.localStorage.getItem(STORAGE_KEY) ?? '';
  } catch {
    return '';
  }
};

export const useSelectedStore = (): readonly [string, (id: string) => void] => {
  const [storeId, setStoreId] = useState<string>(readStored);

  const update = useCallback((id: string) => {
    setStoreId(id);
    try {
      if (id) {
        window.localStorage.setItem(STORAGE_KEY, id);
      } else {
        window.localStorage.removeItem(STORAGE_KEY);
      }
    } catch {
      // localStorage が使えない環境では state のみ更新
    }
  }, []);

  // 別タブで切り替えられた場合に追従する
  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY) {
        setStoreId(e.newValue ?? '');
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return [storeId, update] as const;
};
